import type { WidgetSeriesType, OrderByType } from '@/dashboard/shared/types/widgets.types';

export const DEFAULT_CHART_DATA: {
  SERIES_TYPE: WidgetSeriesType;
  ORDER_BY: OrderByType;
  LIMIT: string;
} = {
  SERIES_TYPE: 'byTarget',
  ORDER_BY: 'ASC',
  LIMIT: '50',
};

export const DEFAULT_TOP_LIST_SORT_TYPE = 'DESC';
